<!--
 * @Author: lwk
 * @Date: 2024-01-31 08:42:44
 * @LastEditors: lwk
 * @LastEditTime: 2024-02-20 09:28:58
 * @Description: 请填写简介
-->

<!--
 * @Author: 
 * @Date: 2024-01-24 09:28:09
 * @LastEditors: lwk
 * @LastEditTime: 2024-02-20 09:24:29
 * @Description: 晨会
-->
<template>
    <div style="background: rgb(246, 248, 251);height: 100vh;width: 100%;">
        <el-container>
          <el-aside width="130px">
            <el-tabs tab-position="left" style="height: 100%;" @tab-click="change_tab" v-model="tabActive">
              <el-tab-pane label="首页看板" name="0"> </el-tab-pane>
              <el-tab-pane label="数据统计" name="1"> </el-tab-pane>
              <el-tab-pane label="在线评价" name="2"> </el-tab-pane>
              <el-tab-pane label="关键工作" name="3"> </el-tab-pane>
            </el-tabs>
          </el-aside>
          <el-main class="mainContent" style="height: 100vh;">
            <div>
              <el-breadcrumb separator="/" style="margin-top: 10px;">
                <el-breadcrumb-item v-for="item,index in tabRlact[tabActive]" :key="index">{{ item }}</el-breadcrumb-item>
              </el-breadcrumb>
              <div style="border-bottom: 2px solid rgb(246, 248, 253);width: 100%;margin: 10px 0;"></div>
              <div v-if="tabActive == '0'">
                <GrayStatistical style="margin-bottom: 15px;"/>
                <ExcellentStatistical/>
              </div>
              <div v-if="tabActive == '1'">
                <DataStatistical/>
              </div>
              <div v-if="tabActive == '2'">
                <OnlineEvaluation/>
              </div>
              <div v-if="tabActive == '3'">
                <CriticalWork/>
              </div>
            </div>
          </el-main>
        </el-container>
    </div>
  </template>
  
  <script>
  import ExcellentStatistical from "@/components/MorningMeeting/ExcellentStatistical";
  import GrayStatistical from "@/components/MorningMeeting/GrayStatistical";
  import DataStatistical from "@/components/MorningMeeting/DataStatistical";
  import OnlineEvaluation from "@/components/MorningMeeting/OnlineEvaluation"
  import CriticalWork from "@/components/MorningMeeting/CriticalWork"
  export default {
    name: "MorningMeet",
    components: { ExcellentStatistical,GrayStatistical,DataStatistical, OnlineEvaluation,CriticalWork },
    data() {
      return {
        tabRlact:{
          '0':['晨会','首页看板'],
          '1':['晨会','数据统计'],
          '2':['晨会','在线评价'],
          '3':['晨会','关键工作'],
        },
        tabActive:'0'
      };
    },
    methods: {
      change_tab(val) {
        this.tabActive = val.name
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .container {
    height: 100%;
  }
  .middle {
    vertical-align: middle;
    /* height: 31px; */
    width: 126px;
    height: 50px;
  }
  .mainContent {
    background: #fff;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/MorningMeet.vue